import createIcon from '../../createIcon';

/**
 * @component @name LineWeight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxN0gyMVYxNUgzVjE3Wk0zIDIwSDIxVjE5SDNWMjBaTTMgMTNIMjFWMTBIM1YxM1pNMyA0VjhIMjFWNEgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LineWeight = createIcon('LineWeight', [
  [
    'path',
    { d: 'M3 17H21V15H3V17ZM3 20H21V19H3V20ZM3 13H21V10H3V13ZM3 4V8H21V4H3Z', key: 'qr5f3l' },
  ],
]);

export default LineWeight;
